<template>
  <div class="d-flex ga-3">
    <div class="d-flex flex-column align-center">
      <span
        class="timeline-dot"
        :style="{
          backgroundColor: statusDotColor[getEventStatus(history.f150Event)],
        }"></span>
      <span v-if="!isLast" class="timeline-line"></span>
    </div>

    <div class="flex-grow-1 pb-4">
      <div class="d-flex justify-space-between ga-2">
        <div>
          <div class="font-weight-bold">
            {{ getEventLabel(history.f150Event) }}
          </div>
          <div class="font-size-13 text-medium-emphasis mt-1">
            <span class="text-disabled">Надіслано:</span>
            <span class="font-weight-medium ml-1">{{ history.sentAt }}</span>
            <span class="text-disabled ml-3">Прийнято:</span>
            <span class="font-weight-medium ml-1">{{ history.passedAt }}</span>
          </div>
        </div>

        <a
          class="link d-flex align-center ga-1 text-no-wrap"
          :href="packageHref"
          target="_blank">
          <span>{{ history.packageCode }}</span>
          <v-icon size="14" icon="mdi-arrow-top-right"></v-icon>
        </a>
      </div>

      <div v-if="history.tranche?.length" class="tranche-box mt-2">
        <div class="font-size-13 text-disabled mb-1">Транші пакета:</div>
        <div class="d-flex flex-column ga-1">
          <div
            v-for="tranche in history.tranche"
            :key="tranche.id"
            class="d-flex align-center ga-2 font-size-13">
            <span
              class="timeline-dot"
              :style="{
                backgroundColor:
                  statusDotColor[getEventStatus(tranche.f150Event)],
              }"></span>
            <span class="id-badge">{{ tranche.id }}</span>
            <span>{{ getEventLabel(tranche.f150Event) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, PropType } from 'vue'
import { useRouter } from 'vue-router'
import type { ChronologyHistory } from '@/utils/types'
import { getEventStatus, getEventLabel, statusDotColor } from './helpers'

export default {
  name: 'ChronologyHistoryItem',
  props: {
    history: {
      type: Object as PropType<ChronologyHistory>,
      required: true,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  methods: { getEventStatus, getEventLabel },
  setup(props) {
    const router = useRouter()

    const packageHref = computed<string>(() => {
      return router.resolve({
        name: 'package-single',
        params: { id: props.history.packageId },
      }).href
    })

    return { packageHref, statusDotColor }
  },
}
</script>

<style scoped lang="scss">
.timeline-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px rgba(var(--v-border-color), 0.1);
}

.timeline-line {
  flex-grow: 1;
  width: 2px;
  background-color: rgba(var(--v-border-color), 0.2);
  opacity: 0.4;
  margin-top: 2px;
}

.tranche-box {
  border-left: 2px solid rgba(var(--v-border-color), 0.4);
  padding-left: 12px;
}

.id-badge {
  font-family: monospace;
  font-size: 12px;
  background-color: rgba(var(--v-theme-on-surface), 0.06);
  border-radius: 4px;
  padding: 1px 6px;
}
</style>
